<template>
  <v-layout row wrap class="colored-background">
    <v-flex xs12 sm12 md12 class="mt-5 text-xs-center">
      <img width="52%" :src="assetRoot + 'musicplus.png'" />
    </v-flex>
    <v-flex xs12 sm12 md12 class="mx-4 my-5 text-xs-center">
      <span class="page-title">Enter your password to finalize your account</span>
    </v-flex>
    <v-flex xs12 sm12 md12 class="text-xs-center mb-5">
      <v-card class="mx-4 rounded-card">
        <v-container>
          <v-layout column>
            <v-text-field class="input-field" :disabled="isFinalizingAccount || accountFinalized"  background-color="grey lighten-2" :type="showPassword1 ? 'text' : 'password'" :append-icon="showPassword1 ? 'visibility' : 'visibility_off'" @click:append="showPassword1 = !showPassword1" single-line outline hide-details v-model="i_password_1">
              <template v-slot:label>
                <span class="input-label">Password</span>
              </template>
            </v-text-field>
            <v-text-field class="mt-2 input-field" :disabled="isFinalizingAccount || accountFinalized"  background-color="grey lighten-2" :type="showPassword2 ? 'text' : 'password'" :append-icon="showPassword2 ? 'visibility' : 'visibility_off'" @click:append="showPassword2 = !showPassword2" single-line outline hide-details v-model="i_password_2">
              <template v-slot:label>
                <span class="input-label">Password</span>
              </template>
            </v-text-field>
            <v-flex class="mt-3">
              <v-btn v-if="accountFinalized" block flat disabled class="rounded-button-done" color="#4caf50">
                <template v-slot:default>
                  <span class="reset-button">ACCOUNT FINALIZED!</span>
                </template>
              </v-btn>
              <v-btn v-else block class="rounded-button" color="#2c7fff"
                :disabled="cantFinalizeAccount || isFinalizingAccount"
                :loading="isFinalizingAccount"
                @click.stop="finalize"
              >
                <template v-slot:default>
                  <span v-if="cantFinalizeAccount" class="reset-button-disabled">FINALIZE</span>
                  <span v-else class="reset-button">FINALIZE</span>
                </template>
              </v-btn>
            </v-flex>
            <v-flex class="mt-3" v-if="finalizeAccountStatus === 'error'">
              <span class="error-message">{{ finalizeAccountErrorMessage }}</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        i_password_1: '',
        i_password_2: '',

        showPassword1: false,
        showPassword2: false,
      }
    },
    methods: {
      finalize () {
        let payload = {
          env: this.env,
          body: {
            app_key: this.appKey,
            device_type: this.deviceType,
            installation_id: this.sessionId,
            confirmation_code: this.$route.params.token,
            password: this.i_password_1
          }
        }
        this.$store.dispatch('FINALIZE_ACCOUNT', payload)
          .then((response) => {
            this.$session.set(this.userInstanceIdStorageKey, response.user_instance_id);
            this.$session.set(this.accessTokenStorageKey, response.access_token);
            this.$session.set(this.accessTokenExpirationTimeStorageKey, response.access_token_expiration_time);
            this.$session.set(this.refreshTokenStorageKey, response.refresh_token);
          })
          .catch((error) => console.log(error))
      }
    },
    computed: {
      ...mapGetters([
        'env',
        
        'assetRoot',
        'appKey',
        'deviceType',
        'sessionId',

        'finalizeAccountStatus',
        'finalizeAccountErrorMessage',

        'userInstanceIdStorageKey',
        'accessTokenStorageKey',
        'accessTokenExpirationTimeStorageKey',
        'refreshTokenStorageKey',
      ]),
      cantFinalizeAccount () {
        return this.$route.params.email === '' || this.$route.params.token === '' || this.i_password_1 === '' || this.i_password_2 === '' || (this.i_password_1 !== this.i_password_2)
      },
      isFinalizingAccount () {
        return this.finalizeAccountStatus === 'progress'
      },
      accountFinalized () {
        return this.finalizeAccountStatus === 'done'
      }
    },
    mounted () {
      this.$nextTick(function () {

      })
    },
    watch: {
      finalizeAccountStatus (newVal) {
        if (newVal === 'done') {
          this.$store.commit('EMAIL_SET', this.$route.params.email)
          this.$store.commit('STORE_MODE_SET', 'finalization')
          let thiz = this
          this.timeout = setTimeout(() => {
            thiz.$router.push('/store')
            clearTimeout(thiz.timeout)
          }, 1000)
        }
      }
    }
  }
</script>

<style scoped>
.colored-background {
  background-size: contain;
  background-image:url('https://storage.googleapis.com/mwm-appstore-assets/website_mwm/global_offer/BG-opti.jpg');
  background-color: #05151F;
}

.page-title {
  font-family: CenturyGothic;
  font-size: 1.5rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.rounded-card{
  border-radius:11px;
}

.input-label {
  font-family: CenturyGothic;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #abadad;
}

.input-field {
  font-family: CenturyGothic;
  font-size: 18px;
  background-color: #f8f8f8;
}

.rounded-button {
  border-radius: 11px;
  height: 48px;
  background-color: #2c7fff;
}

.rounded-button-done {
  border-radius: 11px;
  height: 72px;
  background-color: #4caf50;
}

.reset-button {
  font-family: CenturyGothic;
  font-size: 23px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.87;
  letter-spacing: 1.28px;
  color: #ffffff;
}

.reset-button-disabled {
  font-family: CenturyGothic;
  font-size: 23px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.87;
  letter-spacing: 1.28px;
  color: grey;
}

.error-message {
  font-family: CenturyGothic;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: red;
}
</style>
